export const ADMIN_SRI_ROLES = ["Portal Admin", "Portal SRI User"];

export const isAdminOrSriUser = (appRoles = {}) =>
  Object.values(appRoles).some((role) => ADMIN_SRI_ROLES.includes(role));